/**
 * Plus-Cue カスタムJavaScript
 * プレフィックス: plcu
 */

document.addEventListener('DOMContentLoaded', () => {
  // カスタムヒーローバナー用のスクリプト
  if (document.querySelector('.plcu-hero-banner')) {
    initHeroBanner();
  }

  // カスタムプロダクトグリッド用のスクリプト
  if (document.querySelector('.plcu-product-grid')) {
    initProductGrid();
  }

  // カスタム画像バナーのメディア切り替え機能
  if (document.querySelector('.c-plcu-media-toggle')) {
    initMediaToggle();
  }

  // その他のカスタム機能初期化
  initCustomFeatures();
});

/**
 * ヒーローバナー初期化
 */
function initHeroBanner() {
  // ヒーローバナー関連の処理
}

/**
 * プロダクトグリッド初期化
 */
function initProductGrid() {
  // プロダクトグリッド関連の処理
}

/**
 * カスタム画像バナーのメディア切り替え機能初期化
 */
function initMediaToggle() {
  const toggleButtons = document.querySelectorAll('.c-plcu-media-toggle');
  
  toggleButtons.forEach(button => {
    button.addEventListener('click', function() {
      const sectionId = this.id.replace('media-toggle-', '');
      toggleMedia(sectionId);
    });
  });
}

/**
 * メディア切り替え処理
 * @param {string} sectionId - セクションID
 */
function toggleMedia(sectionId) {
  const button = document.getElementById(`media-toggle-${sectionId}`);
  const buttonText = button.querySelector('.c-c-plcu-media-toggle__text');
  
  // デスクトップ要素
  const imageDesktop = document.getElementById(`image-desktop-${sectionId}`);
  const videoDesktop = document.getElementById(`video-desktop-${sectionId}`);
  
  // モバイル要素
  const imageMobile = document.getElementById(`image-mobile-${sectionId}`);
  const videoMobile = document.getElementById(`video-mobile-${sectionId}`);
  
  // 現在の表示状態を確認
  const isShowingVideo = !videoDesktop?.classList.contains('u-plcu-media-hidden') ||
                        !videoMobile?.classList.contains('u-plcu-media-hidden');
  
  if (isShowingVideo) {
    // ビデオから画像に切り替え
    if (imageDesktop) imageDesktop.classList.remove('u-plcu-media-hidden');
    if (imageMobile) imageMobile.classList.remove('u-plcu-media-hidden');
    if (videoDesktop) videoDesktop.classList.add('u-plcu-media-hidden');
    if (videoMobile) videoMobile.classList.add('u-plcu-media-hidden');
    
    // ビデオを停止
    stopVideos(sectionId);
    
    buttonText.textContent = 'ビデオ表示';
  } else {
    // 画像からビデオに切り替え
    if (imageDesktop) imageDesktop.classList.add('u-plcu-media-hidden');
    if (imageMobile) imageMobile.classList.add('u-plcu-media-hidden');
    if (videoDesktop) videoDesktop.classList.remove('u-plcu-media-hidden');
    if (videoMobile) videoMobile.classList.remove('u-plcu-media-hidden');
    
    // ビデオを再生
    playVideos(sectionId);
    
    buttonText.textContent = '画像表示';
  }
}

/**
 * ビデオ再生
 * @param {string} sectionId - セクションID
 */
function playVideos(sectionId) {
  const videoDesktop = document.querySelector(`#video-desktop-${sectionId} video`);
  const videoMobile = document.querySelector(`#video-mobile-${sectionId} video`);
  
  if (videoDesktop && !videoDesktop.classList.contains('u-plcu-media-hidden')) {
    videoDesktop.play().catch(e => console.log('Video autoplay prevented:', e));
  }
  
  if (videoMobile && !videoMobile.classList.contains('u-plcu-media-hidden')) {
    videoMobile.play().catch(e => console.log('Video autoplay prevented:', e));
  }
}

/**
 * ビデオ停止
 * @param {string} sectionId - セクションID
 */
function stopVideos(sectionId) {
  const videoDesktop = document.querySelector(`#video-desktop-${sectionId} video`);
  const videoMobile = document.querySelector(`#video-mobile-${sectionId} video`);
  
  if (videoDesktop) {
    videoDesktop.pause();
    videoDesktop.currentTime = 0;
  }
  
  if (videoMobile) {
    videoMobile.pause();
    videoMobile.currentTime = 0;
  }
}

/**
 * カスタム機能の初期化
 */
function initCustomFeatures() {
  // 共通のカスタム機能
}